import React from 'react';
import styled, { css } from 'styled-components';
import { getIn } from 'seamless-immutable';
import { Nav } from '@catalogo/core-nav';

const WeddingList = props => {
  const { currentSku, isDesk } = props;
  const skuId = getIn(currentSku, ['id']);
  const url = `http://listadecasamento.americanas.com.br/rest/AddGift/?sku=${skuId}`;

  return (
    <ButtonUI to={url} isDesk={isDesk}>
      <BuyButtonText>adicionar à lista de casamento</BuyButtonText>
    </ButtonUI>
  );
};

const BuyButtonText = styled.span`
  font-size: 12px;
  text-align: center;
  font-weight: bold;
  color: #999;
  margin-top: -3px;
`;

export const ButtonUI = styled(Nav)`
  width: 48%;
  padding: 10px 12px;
  border-radius: 3px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 70%;
  &:hover {
    background-color: #f8f8f8;
  }

  ${({ isDesk }) =>
    isDesk &&
    css`
      width: 100%;
      padding: 15px 10px;
      margin-top: 10px;

      & > span {
        font-size: 14px;
      }
    `}
`;

export default WeddingList;
